import React from 'react';

const TermsOfUse: React.FC = () => {
  return (
    <div className="py-24 bg-white dark:bg-gray-900">
      <div className="container mx-auto px-4 md:px-6">
        <h1 className="font-display text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-8">
          Conditions d'Utilisation
        </h1>
        
        <div className="prose prose-lg dark:prose-invert max-w-none">
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Acceptation des conditions</h2>
            <p>
              En accédant et en utilisant le site web de MGE COUVERTURE, vous acceptez d'être lié par les présentes conditions d'utilisation, toutes les lois et réglementations applicables, et vous acceptez que vous êtes responsable du respect des lois locales applicables. Si vous n'acceptez pas l'une de ces conditions, vous êtes interdit d'utiliser ou d'accéder à ce site.
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Utilisation du site</h2>
            <p>
              Le contenu du site web de MGE COUVERTURE est destiné à votre information générale et à votre utilisation personnelle uniquement. Il est sujet à modification sans préavis.
            </p>
            <p>
              Ce site web utilise des cookies pour surveiller les préférences de navigation. Si vous autorisez l'utilisation de cookies, certaines informations personnelles peuvent être stockées par nous pour une utilisation future par le site.
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Limitations de responsabilité</h2>
            <p>
              MGE COUVERTURE ou ses fournisseurs ne seront pas tenus responsables de tout dommage résultant de l'utilisation ou de l'impossibilité d'utiliser les matériaux sur le site web de MGE COUVERTURE, même si MGE COUVERTURE ou un représentant autorisé de ce site a été informé oralement ou par écrit de la possibilité de tels dommages.
            </p>
            <p>
              Dans certaines juridictions, les limitations de responsabilité implicites ou l'exclusion de responsabilité pour les dommages accessoires ou indirects ne sont pas autorisées, ce qui signifie que certaines des limitations ci-dessus peuvent ne pas s'appliquer à vous.
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Exactitude des matériaux</h2>
            <p>
              Les matériaux apparaissant sur le site web de MGE COUVERTURE pourraient inclure des erreurs techniques, typographiques ou photographiques. MGE COUVERTURE ne garantit pas que les matériaux de ce site web sont exacts, complets ou à jour. MGE COUVERTURE peut modifier les matériaux contenus sur son site web à tout moment sans préavis.
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Liens</h2>
            <p>
              MGE COUVERTURE n'a pas examiné tous les sites liés à son site web et n'est pas responsable du contenu de ces sites liés. L'inclusion de tout lien n'implique pas l'approbation par MGE COUVERTURE du site. L'utilisation de tout site web lié est aux risques et périls de l'utilisateur.
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Modifications</h2>
            <p>
              MGE COUVERTURE peut réviser ces conditions d'utilisation de son site web à tout moment sans préavis. En utilisant ce site web, vous acceptez d'être lié par la version alors en vigueur de ces conditions d'utilisation.
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Droit applicable</h2>
            <p>
              Ces conditions sont régies et interprétées conformément aux lois françaises, et vous vous soumettez irrévocablement à la juridiction exclusive des tribunaux de Paris, France.
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Contact</h2>
            <p>
              Si vous avez des questions concernant ces conditions d'utilisation, vous pouvez nous contacter :
            </p>
            <p>
              <strong>Par email :</strong> legal@mgecouverture.fr<br />
              <strong>Par courrier :</strong> MGE COUVERTURE, 123 Avenue de la Construction, 75001 Paris<br />
              <strong>Par téléphone :</strong> 01 23 45 67 89
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
